module.exports = __webpack_public_path__ + "img/r.1e6a19af.png";